import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: false,
            text: 'wRVU Goal Trend',
            position: "top"
        },
    },
    scales: {
        y: {
            ticks: {
                color: "#01959E",
                font: {
                    // size: 18,
                },
                stepSize: 1,
                beginAtZero: true
            }
        },
        x: {
            ticks: {
                color: "#01959E",
                font: {
                    // size: 14
                },
                stepSize: 1,
                beginAtZero: true
            }
        }
    }
};

const labels = ['07/2022', '08/2022', '09/2022', '10/2022', '11/2022', '12/2022', '01/2022', '02/2022', '03/2022', '04/2022', '05/2022', '06/2022',];

const datas = [90, 70, 60, 80, 30, 40, 70, 60, 80, 90, 60, 50]

export const data = {
    labels,
    datasets: [
        {
            label: 'Dataset 1',
            data: datas,
            backgroundColor: datas.map(data => {
                if (data <= 70) {
                    return "#E96058"
                } else {
                    return "#01959E"
                }
            }),
        }
    ],
};

const LeftChartComponent = () => {
    return (
        <Bar options={options} data={data} />
    );
};

export default LeftChartComponent;